import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  OnboardingFlowContent,
  OnboardingProvider,
  useIsAdmin,
  useOnboardingStatus,
} from '../../components/onboarding-new';
import { useMemory } from '../../api/memory';

import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/onboarding/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('pleri/pages');
  const navigate = useNavigate();
  const { isLoading: isLoadingStatus } = useOnboardingStatus();
  const isAdmin = useIsAdmin();
  const { data: userMemory, isLoading: isLoadingUserMemory } = useMemory();

  // Check if user memory exists (has meaningful data) - compute directly from data
  // Only compute once when data is first available, using ref to track if computed
  const hasComputedInitial = React.useRef(false);
  const computedMemoryFlags = React.useRef<{
    hasUserMemory: boolean;
  }>({ hasUserMemory: false });

  if (!hasComputedInitial.current && !isLoadingUserMemory) {
    // Check user memory
    if (userMemory?.memory) {
      const mem = userMemory.memory;
      computedMemoryFlags.current.hasUserMemory = !!(
        mem.nickName ||
        mem.role ||
        mem.communicationPreference
      );
    }

    hasComputedInitial.current = true;
  }

  const hasUserMemory = computedMemoryFlags.current.hasUserMemory;

  const isLoading = isLoadingStatus || isLoadingUserMemory;

  // Show loading state
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg text-gray-600 dark:text-gray-400">
          {t('common:loading')}
        </div>
      </div>
    );
  }

  const handleComplete = () => {
    // Onboarding is complete - memory updates have already been made
    // Redirect to chat
    // navigate({
    //   to: '/c/$conversationId',
    //   params: { conversationId: 'new' },
    //   replace: true,
    // });
  };

  const handleClose = () => {
    navigate({
      to: '/c/$conversationId',
      params: { conversationId: 'new' },
      replace: true,
    });
  };

  return (
    <OnboardingProvider isAdmin={isAdmin} hasUserMemory={hasUserMemory}>
      <OnboardingFlowContent
        onComplete={handleComplete}
        onClose={handleClose}
        canSkipSteps={true}
      />
    </OnboardingProvider>
  );
}
